import React from "react";
import {
  Link,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import About from "./pages/About";
import Home from "./pages/Home";
import Media from "./pages/Media";
import Resume from "./pages/Resume";
import Video from "./pages/Video";
import Writing from "./pages/Writing";
import Blogs from "./pages/blog/Blog";
import Hard from "./pages/projects/75hard/75hard";
import BookClub from "./pages/projects/bookclub";
import CarbonCalc from "./pages/projects/carboncalc/carboncalc";
import WakeupLogger from "./pages/projects/daylog/dayLogger";
import EditWorkoutHistory from "./pages/projects/fitness/components/edit-workouts";
import FullWorkoutHistory from "./pages/projects/fitness/components/full-workout-history";
import StravaPage from "./pages/projects/fitness/components/strava";
import StravaEditorPage from "./pages/projects/fitness/components/strava-editor";
import WorkoutHistory2 from "./pages/projects/fitness/components/workouthistory2";
import LandingPage from "./pages/projects/fitness/landing/landing";
import LoginPage from "./pages/projects/fitness/login";
import TrackerPage from "./pages/projects/fitness/tracker";
import EditReceipt from "./pages/projects/foodbudget/edit";
import FoodBudget from "./pages/projects/foodbudget/foodbudget";
import FoodLandingPage from "./pages/projects/foodbudget/landing";
import LoginPageFood from "./pages/projects/foodbudget/login";
import PurchaseHistory from "./pages/projects/foodbudget/purchaseHistory";
import Gre from "./pages/projects/gre/grelog";
import GreLandingPage from "./pages/projects/gre/habittracker";
import LoginPageHabit from "./pages/projects/gre/login";
import HowMuchMade from "./pages/projects/howmuchimade/howmuchhaveimade";
import TopNews from "./pages/projects/news/topnews";

import Projects from "./pages/projects/projects";
import ResumeAI from "./pages/projects/resume/resumeai";
import Ira from "./pages/projects/stocks/ira";

import SpendEdit from "./pages/components/spend-tracker/edit";
import AccountsPage from "./pages/projects/spend-tracker/AccountsPage";
/*import SettingsPage from "./pages/projects/spend-tracker/SettingsPage";*/
import SpendDashboard from "./pages/projects/spend-tracker/SpendDashboard";
import LandingPageSpend from "./pages/projects/spend-tracker/landing";
import LoginPageSpend from "./pages/projects/spend-tracker/login-spend";

import Cura from "./pages/projects/cura/cura";

const App: React.FC = () => (
  <Router>
    <AppWithNav />
  </Router>
);

const AppWithNav: React.FC = () => {
  const [isProjectsOpen, setIsProjectsOpen] = React.useState(false);
  const location = useLocation();
  const isTopNewsPage = location.pathname === "/topnews";
  const isCuraPage = location.pathname === "/cura";

  // Hide header on Cura page
  const shouldShowHeader = !isCuraPage;

  const menuItems = [
    { path: "/", label: "Home" },
    { path: "/resume", label: "Resume" },
    { path: "/projects", label: "Projects" },
  ];

  const projectItems = [
    { path: "/blogs", label: "Blogs" },
    { path: "/video", label: "Video" },
    { path: "/writing", label: "Writing" },
    { path: "/media", label: "Media" },
  ];

  const styles: Record<string, React.CSSProperties> = {
    header: {
      backgroundColor: isTopNewsPage ? "#000" : "white",
      color: isTopNewsPage ? "#fff" : "#000",
      textAlign: "center" as const,
    },
    title: {
      fontSize: "24px",
      marginBottom: "20px",
      color: isTopNewsPage ? "#fff" : "#000",
    },
    nav: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap" as const,
      gap: "15px",
    },
    link: {
      color: isTopNewsPage ? "#fff" : "#000",
      textDecoration: "none",
      fontSize: "16px",
      padding: "5px",
    },
    dropdownContainer: {
      position: "relative" as const,
      display: "inline-block",
    },
    dropdownButton: {
      background: "none",
      border: "none",
      color: isTopNewsPage ? "#fff" : "#000",
      fontSize: "16px",
      cursor: "pointer",
      padding: "5px",
      fontFamily: '"Times New Roman", Times, serif',
    },
    dropdownContent: {
      display: isProjectsOpen ? "block" : "none",
      position: "absolute" as const,
      backgroundColor: isTopNewsPage ? "#111" : "white",
      minWidth: "140px",
      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
      zIndex: 1,
      top: "100%",
      left: "50%",
      transform: "translateX(-50%)",
      borderRadius: "4px",
    },
    dropdownLink: {
      color: isTopNewsPage ? "#fff" : "#000",
      textDecoration: "none",
      padding: "8px 12px",
      display: "block",
      textAlign: "center" as const,
    },
    mainContainer: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column" as const,
      fontFamily: '"Times New Roman", Times, serif',
    },
    main: {
      flex: 1,
      padding: isTopNewsPage || isCuraPage ? "0" : "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      backgroundColor: isTopNewsPage ? "#000" : "white",
      color: isTopNewsPage ? "#fff" : "#000",
    },
  };

  return (
    <div style={styles.mainContainer}>
      {shouldShowHeader && (
        <header style={styles.header}>
          <h1 style={styles.title}>Jack Pearson</h1>
          <nav style={styles.nav}>
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  ...styles.link,
                  fontWeight:
                    location.pathname === item.path ? "bold" : "normal",
                }}
              >
                {item.label}
              </Link>
            ))}

            <div
              style={styles.dropdownContainer}
              onMouseEnter={() => setIsProjectsOpen(true)}
              onMouseLeave={() => setIsProjectsOpen(false)}
            >
              <button style={styles.dropdownButton}>More ▾</button>
              <div style={styles.dropdownContent}>
                {projectItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    style={{
                      ...styles.dropdownLink,
                      fontWeight:
                        location.pathname === item.path ? "bold" : "normal",
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </nav>
        </header>
      )}

      <main style={styles.main}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="/video" element={<Video />} />
          <Route path="/writing/*" element={<Writing />} />
          <Route path="/blog/*" element={<Blogs />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/stocks/ira" element={<Ira />} />
          <Route path="/75hard" element={<Hard />} />
          <Route path="/carboncalc" element={<CarbonCalc />} />
          <Route path="/daylogger" element={<WakeupLogger />} />
          <Route path="/bookclub" element={<BookClub />} />
          <Route path="/media" element={<Media />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login-food" element={<LoginPageFood />} />
          <Route path="/tracker" element={<TrackerPage />} />
          <Route path="/full-history" element={<FullWorkoutHistory />} />
          <Route path="/resumeai" element={<ResumeAI />} />
          <Route path="/edit-workouts" element={<EditWorkoutHistory />} />
          <Route path="/workout-history" element={<WorkoutHistory2 />} />
          <Route path="/strava" element={<StravaPage />} />
          <Route path="/strava-editor" element={<StravaEditorPage />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/foodlanding" element={<FoodLandingPage />} />
          <Route path="/gre" element={<Gre />} />
          <Route path="/foodbudget" element={<FoodBudget />} />
          <Route
            path="/purchase-history"
            element={<PurchaseHistory uid={""} />}
          />
          <Route path="/foodbudget/edit/:id" element={<EditReceipt />} />
          <Route path="/habittracker" element={<GreLandingPage />} />
          <Route path="/login-gre" element={<LoginPageHabit />} />
          <Route path="/howmuchhaveimade" element={<HowMuchMade />} />
          <Route path="/topnews" element={<TopNews />} />

          <Route path="/money" element={<SpendDashboard />} />
          <Route path="/money/accounts" element={<AccountsPage />} />
          {/*<Route path="/money/settings" element={<SettingsPage />} />*/}
          <Route path="/login-spend" element={<LoginPageSpend />} />
          <Route path="/money/landing" element={<LandingPageSpend />} />
          <Route path="/money/edit" element={<SpendEdit />} />

          <Route path="/cura" element={<Cura />} />
        </Routes>
      </main>
    </div>
  );
};

export default App;
